module.exports = __webpack_public_path__ + "static/media/btn_apple_ita.5bb8b507.png";